export default {
  ADD_META_TAGS (state, metaTags) {
    state.metaTags = metaTags
  },
  ADD_META_TAG_SCHEMA (state, metaTagSchema) {
    state.metaTags.unshift(metaTagSchema)
  },
  ADD_NEW_META_TAG (state, newMetaTag) {
    const metaTag = state.metaTags.find(m => m.tempId === newMetaTag.tempId)
    metaTag.isNew = false
    metaTag.url = newMetaTag.url
    metaTag.title = newMetaTag.title
    metaTag.description = newMetaTag.description
    metaTag.keywords = newMetaTag.keywords
    metaTag.id = newMetaTag.id
  },
  DELETE_META_TAG (state, metaTagId) {
    state.metaTags = state.metaTags.filter(m => m.id !== metaTagId)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/metaTags.js